export default "__VITE_ASSET__Dc8nCt3U__"